import React, { createContext, useContext } from "react"
import type { ReactNode } from "react"

export type TelemetryValue = Record<string, unknown> | false

export type TelemetryProps = {
  value?: TelemetryValue
  children?: ReactNode
}

const TelemetryContext = createContext<TelemetryValue | undefined>(undefined)

export function useTelemetry(localTelemetry?: TelemetryValue): TelemetryValue {
  const contextTelemetry = useContext(TelemetryContext)

  if (localTelemetry === false) return false
  if (contextTelemetry === false) return localTelemetry || false

  return { ...contextTelemetry, ...localTelemetry }
}

export const Telemetry = ({ value, children }: TelemetryProps) => {
  const parentTelemetry = useContext(TelemetryContext)

  let mergedTelemetry: TelemetryValue | undefined
  if (value === false) {
    // This component disabled telemetry for its subtree.
    mergedTelemetry = false
  } else if (parentTelemetry === false) {
    // A parent disabled telemetry, but this component provides its own.
    mergedTelemetry = value || false
  } else {
    // Both parent and local telemetry exist. Merge them.
    mergedTelemetry = { ...parentTelemetry, ...value }
  }

  return (
    <TelemetryContext.Provider value={mergedTelemetry}>
      {children}
    </TelemetryContext.Provider>
  )
}
